<div class="d-flex align-items-stretch">
  <jc-navigation></jc-navigation>

  <div id="main" class="w-100">
    <router-outlet></router-outlet>
  </div>
</div>

<jc-meh></jc-meh>
